/*
File Name: request.js
Created Date: 2020-08-28 13:49:51
Author: yeyong
Last modified: 2020-09-01 15:55:27
*/
import axios from 'axios'
import router from '../router'
import {MessageBox} from 'element-ui'
import store from '../store'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    withCredentials: true,
    timeout: 10000 * 60 * 3,
    headers: {"Content-Type": "application/x-www-form-urlencoded"},
    transformRequest: [(data) => {
        if (data) {
            return Object.entries(data).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&")
        } else {
            return data
        }
    }],
    tranformResponses: [(data) => {
        return data
    }]
})

service.interceptors.request.use(
    config => {
        config.headers["Authorization"]= localStorage.getItem("token")
        return config
    }, error => {
        console.log("错误: ", error)
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        var res = response.data
        if (res.code !== 200) {
            if (res.code === 419) {
                store.dispatch('logout').then(res => {
                    router.push(
                        {
                            path:"/login", 
                            query: {redirect: router.app._route.fullPath}
                    })
                })
                return res
            }
            if ([422, 404, 400].includes(res.code)) {
                MessageBox({title: "提示", message: res.msg, type: "error"})
                return res
            }
            return Promise.reject()
        } else {
            return res
        }
    }, error => {
        console.log("出现了错误: ", error)
        return Promise.reject(error)
    }
)
export default service
